import { defaultTableOptions } from "./tableOptions";import React, { useEffect, useState } from "react";
import axios from "axios";
import {
// LinearProgress,
// Button,
Paper,
Grid,
Table,
TableBody,
TableCell,
TableContainer,
TableRow,
TableHead,
TablePagination,
// Divider,
// TextField,
// Dialog,
// DialogTitle,
// DialogContent,
// DialogContentText,
// DialogActions,
CircularProgress } from
"@material-ui/core";
import SvgImage from "../asserts/images/search_results.svg";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { withStyles } from "@material-ui/core/styles";
import { useParams } from "react-router";
import Card from "../components/dashboard/dashboard_component/view/Card/Card";
import CardHeader from "../components/dashboard/dashboard_component/view/Card/CardHeader";
import MaterialTable from "material-table";
import rigvlogo from "../asserts/images/rigv2.png";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}>

			{value === index &&
      <Box p={3}>
					<Typography>{children}</Typography>
				</Box>}

		</div>);

}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired };


function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}` };

}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: "10px" } }));



const StyledTableRowStoppage = withStyles((theme) => ({
  head: {
    backgroundColor: " #DAF7A6		",
    color: "black" },

  body: {
    fontSize: 14 } }))(

TableRow);

const StyledTableRowStoppage2 = withStyles((theme) => ({
  head: {
    backgroundColor: "#e4ecf2",
    color: "black" },

  body: {
    fontSize: 14 } }))(

TableRow);
const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover } } }))(


TableRow);
const StyledTableRow2 = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover } } }))(


TableRow);
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#e4ecf2",
    color: theme.palette.common.black },

  body: {
    fontSize: 14 } }))(

TableCell);
const list = { fontSize: 16 };
const TableCellStyle = { fontSize: "15px" };
const tableCellStyle = { fontSize: "16px", fontWeight: "bold" };
const TableRowData = { fontSize: "16px", fontWeight: "bold" };
const TokenCopyView = () => {
  let { any } = useParams();
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [value, setValue] = useState(0);
  const [success, setSuccess] = useState();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // const handleChangePage = (event, newPage) => {
  // 	setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  // 	setRowsPerPage(parseInt(event.target.value, 10));
  // 	setPage(0);
  // };
  const [response, setResponse] = useState({});
  const postTokenDetail = async () => {
    const getTokenList = {
      method: "get",
      url: `${process.env.REACT_APP_urlProtocol}${process.env.REACT_APP_url}:${process.env.REACT_APP_port}/api/token/inspector/${any}`,
      withCredentials: true,
      headers: { crossDomain: true, "Content-Type": "application/json" } };


    try {
      const resp = await axios(getTokenList);
      setSuccess(resp.data.success);
      setResponse(resp.data.info);
      // console.log(resp.data.info.Trip);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    postTokenDetail();
  }, []);
  const [progress, setProgress] = useState(0);
  // console.log(progress);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
      prevProgress >= 150 ? 150 : prevProgress + 10);

    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);
  // console.log("Trips", response);
  return (
    <div>
			{success === 0 ?
      <div>
					<img src={SvgImage} />
					<Typography variant="h4">Token Expire</Typography>
				</div> :
      !response.deviceInfo ?
      <CircularProgress /> :

      <Grid lg={12} item container spacing={3} direction="row">
					<Grid item lg={6} sm={11} md={12} xs={12}>
						<Card>
							<CardHeader color="info">
								<h2 style={{ float: "left" }}>
									<img
                src={rigvlogo}
                style={{
                  verticalAlign: "middle",
                  boxShadow: "1px 2px 1px black",
                  borderRadius: 45 }} />


								</h2>
								<br />
								<Typography
              variant="h5"
              style={{
                float: "left",
                marginLeft: "10px"
                // marginTop: "11px",
                // fontSize: "23px",
                // fontWeight: "bold",
              }}>

									{response.deviceInfo.deviceName}
								</Typography>
								<br />
								<br />

								<Typography style={{ float: "left", paddingLeft: "10px" }}>
									Expire On : {response.expireOn}
								</Typography>
								{/* <br />
                <div style={{ float: "left" }}>
                <p
                style={{
                float: "left",
                marginLeft: "-280px",
                marginTop: "-5px",
                fontSize: "15px",
                fontWeight: "bold",
                }}
                ></p>
                </div> */}
							</CardHeader>

							<TableContainer>
								<Table aria-label="a dense table">
									<TableBody>
										<StyledTableRow>
											<TableCell component="th" scope="row" style={list}>
												IMEI Number
											</TableCell>
											<TableCell align="left">
												<span style={{ fontSize: "16px", fontWeight: "bold" }}>
													{response.deviceInfo.IMEI === null ?
                        "-" :
                        response.deviceInfo.IMEI}
												</span>
											</TableCell>
											<TableCell align="left"></TableCell>
										</StyledTableRow>

										<StyledTableRow>
											<TableCell component="th" scope="row" style={list}>
												Status Mining
											</TableCell>
											<TableCell align="left">
												{(() => {
                        if (
                        response.deviceInfo.miningStatus == "loaded" &&
                        response.deviceInfo.miningStatus !== null)
                        {
                          return (
                            <span
                            style={{
                              color: "#28a745",
                              fontSize: "16px",
                              fontWeight: "bold" }}>


																loaded
															</span>);

                        } else if (
                        response.deviceInfo.miningStatus == "empty" &&
                        response.deviceInfo.miningStatus !== null)
                        {
                          return (
                            <span
                            style={{
                              color: "#ff9800",
                              fontSize: "16px",
                              fontWeight: "bold" }}>


																{" "}
																empty
															</span>);

                        } else if (
                        response.deviceInfo.miningStatus == "loading" &&
                        response.deviceInfo.miningStatus !== null)
                        {
                          return (
                            <span
                            style={{
                              color: "#9c27b0",
                              fontSize: "16px",
                              fontWeight: "bold" }}>


																{" "}
																loading
															</span>);

                        } else if (
                        response.deviceInfo.miningStatus == "unloading" &&
                        response.deviceInfo.miningStatus !== null)
                        {
                          return (
                            <span
                            style={{
                              color: "#007bff",
                              fontSize: "16px",
                              fontWeight: "bold" }}>


																{" "}
																unloading
															</span>);

                        } else if (
                        response.deviceInfo.miningStatus == "suspend" &&
                        response.deviceInfo.miningStatus !== null)
                        {
                          return (
                            <span
                            style={{
                              color: "red",
                              fontSize: "16px",
                              fontWeight: "bold" }}>


																{" "}
																suspend
															</span>);

                        }
                      })()}
											</TableCell>
											<TableCell align="left"></TableCell>
										</StyledTableRow>

										<StyledTableRow>
											<TableCell component="th" scope="row" style={list}>
												Power
											</TableCell>
											<TableCell align="left">
												{(() => {
                        if (
                        response.deviceInfo.power === "powerCut" &&
                        response.deviceInfo.power !== null)
                        {
                          return (
                            <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold" }}>


																powerCut
															</span>);

                        } else if (
                        response.deviceInfo.power === null &&
                        response.deviceInfo.power !== null)
                        {
                          return (
                            <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold" }}>


																-
															</span>);

                        } else if (
                        response.deviceInfo.power === "powerRestore" &&
                        response.deviceInfo.power !== null)
                        {
                          return (
                            <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold" }}>


																powerRestore
															</span>);

                        } else return <span>-</span>;
                      })()}
											</TableCell>
											<TableCell align="left"></TableCell>
										</StyledTableRow>
										<StyledTableRow>
											<TableCell component="th" scope="row" style={list}>
												Motion
											</TableCell>
											<TableCell align="left">
												{(() => {
                        if (
                        response.data.motion === "stopped" &&
                        response.data.motion !== null)
                        {
                          return (
                            <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold" }}>


																stopped
															</span>);

                        } else if (
                        response.data.motion === "moving" &&
                        response.data.power !== null)
                        {
                          return (
                            <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold" }}>


																moving
															</span>);

                        } else return <span>-</span>;
                      })()}
											</TableCell>
											<TableCell align="left"></TableCell>
										</StyledTableRow>

										<StyledTableRow>
											<TableCell component="th" scope="row" style={list}>
												Last GPS Located
											</TableCell>
											<TableCell
                    align="left"
                    style={{ fontSize: "16px", fontWeight: "bold" }}>

												{response.deviceInfo.currenttime === null ?
                      "-" :
                      response.deviceInfo.currenttime}
											</TableCell>
											<TableCell align="left">
												<a
                      href={`https://maps.google.com/maps?q=${response.deviceInfo.latitude},${response.deviceInfo.longitude}`}
                      // target="_blank"  ::: for multiple new window tab
                      target="blank" // for single window tab
                      style={{
                        textDecoration: "none",
                        color: "blue",
                        fontSize: "15px",
                        verticalAlign: "middle" }}>


													<LocationOnIcon
                        style={{
                          color: "red",
                          verticalAlign: "middle",
                          marginBottom: "5px" }} />


													Click
												</a>
											</TableCell>
										</StyledTableRow>
									</TableBody>
								</Table>
							</TableContainer>
							<TableContainer>
								<Table aria-label="a dense table">
									<TableBody>
										<StyledTableRow2>
											<TableCell component="th" scope="row" style={list}>
												Group Name
											</TableCell>
											<TableCell
                    align="left"
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      paddingLeft: "150px" }}>


												{response.groupName.map((item, index) => {
                        return <div key={index}>{item},</div>;
                      })}
											</TableCell>
										</StyledTableRow2>
										{/* <StyledTableRow2>
                    <TableCell component="th" scope="row" style={list}>
                    	Run With Km
                    </TableCell>
                    <TableCell
                    	align="left"
                    	style={{
                    		fontSize: "16px",
                    		fontWeight: "bold",
                    		paddingLeft: "150px",
                    	}}
                    >
                    	{response.kilometer} Km
                    </TableCell>
                    </StyledTableRow2> */}
									</TableBody>
								</Table>
							</TableContainer>
						</Card>
					</Grid>

					<Grid item lg={6} sm={11} md={12} xs={12}>
						<div className={classes.root}>
							<AppBar position="static" style={{ backgroundColor: "#007bff" }}>
								<Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example">

									<Tab
                label="Trip"
                {...a11yProps(0)}
                style={{ fontWeight: "bold" }} />

									<Tab
                label="Stoppage"
                {...a11yProps(1)}
                style={{ fontWeight: "bold" }} />

									<Tab
                label="Events"
                {...a11yProps(2)}
                style={{ fontWeight: "bold" }} />

								</Tabs>
							</AppBar>
							<TabPanel value={value} index={0}>
								{/* {!response.Trip ? (
                progress === 150 ? (
                	<h1>hello</h1>
                ) : (
                	<CircularProgress value={progress} variant="determinate" />
                )
                ) : ( */}
								<Paper elevation={3} style={{ width: "100%", height: "100%" }}>
									<Paper elevation={0} className={classes.innerPaper}>
										<TableContainer component={Paper}>
											<Table
                    className={classes.table}
                    aria-label="simple table">

												<TableHead>
													<TableRow>
														<StyledTableCell style={tableCellStyle}>
															Sr.No
														</StyledTableCell>
														<StyledTableCell style={tableCellStyle}>
															Loaded Time
														</StyledTableCell>
														<StyledTableCell style={tableCellStyle}>
															Location
														</StyledTableCell>
														<StyledTableCell
                          align="left"
                          style={tableCellStyle}>

															Unloading Time
														</StyledTableCell>
														<StyledTableCell style={tableCellStyle}>
															Location
														</StyledTableCell>
														<StyledTableCell
                          align="center"
                          style={tableCellStyle}>

															Loaded to Unloading Time Interval
														</StyledTableCell>
													</TableRow>
												</TableHead>
												{/* <TableBody>
                        {response.Trip.map((row, index) => {
                        	return row.loadedtime == null ? null : (
                        		<TableRow hover>
                        			<TableCell>{index + 1}</TableCell>
                        			<TableCell component="th" scope="row">
                        				{row.loadedtime}
                        			</TableCell>
                        		</TableRow>
                        	);
                        })}
                        </TableBody> */}
												<TableBody>
													{response.Trip.map((row, index) => {
                          return row.loadedtime == null ? null :
                          <TableRow
                          // key={row.loadeddeviceId}
                          hover>

																<TableCell>{index}</TableCell>
																<TableCell component="th" scope="row">
																	{row.loadedtime}
																</TableCell>
																<TableCell align="left">
																	<a
                              href={`https://maps.google.com/maps?q=${row.loadedlatitude},${row.loadedlongitude}`}
                              // target="_blank"  ::: for multiple new window tab
                              target="blank" // for single window tab
                              style={{
                                textDecoration: "none",
                                color: "blue",
                                fontSize: "15px",
                                verticalAlign: "middle" }}>


																		<LocationOnIcon
                                style={{
                                  color: "red",
                                  verticalAlign: "middle",
                                  marginBottom: "5px" }} />


																		Click
																	</a>
																</TableCell>
																<TableCell align="left">
																	{row.unloadingtime}
																</TableCell>
																<TableCell align="left">
																	<a
                              href={`https://maps.google.com/maps?q=${row.unloadinglatitude},${row.unloadinglongitude}`}
                              // target="_blank"  ::: for multiple new window tab
                              target="blank" // for single window tab
                              style={{
                                textDecoration: "none",
                                color: "blue",
                                fontSize: "15px",
                                verticalAlign: "middle" }}>


																		<LocationOnIcon
                                style={{
                                  color: "red",
                                  verticalAlign: "middle",
                                  marginBottom: "5px" }} />


																		Click
																	</a>
																</TableCell>

																<TableCell align="center">
																	{(() => {
                                if (row.loadedToUnloadingTime.d != "0") {
                                  return (
                                    " " +
                                    " " +
                                    row.loadedToUnloadingTime.d +
                                    " " +
                                    "Day" +
                                    " " +
                                    " ");

                                }
                              })()}
																	{(() => {
                                if (row.loadedToUnloadingTime.h != "0") {
                                  return (
                                    " " +
                                    " " +
                                    row.loadedToUnloadingTime.h +
                                    " " +
                                    "Hour" +
                                    " " +
                                    " ");

                                }
                              })()}
																	{(() => {
                                if (row.loadedToUnloadingTime.m != "0") {
                                  return (
                                    " " +
                                    " " +
                                    row.loadedToUnloadingTime.m +
                                    " " +
                                    "Min" +
                                    " " +
                                    " ");

                                }
                              })()}
																	{(() => {
                                if (row.loadedToUnloadingTime.s != "0") {
                                  return (
                                    " " +
                                    " " +
                                    row.loadedToUnloadingTime.s +
                                    " " +
                                    "Sec");

                                }
                              })()}
																</TableCell>
															</TableRow>;

                        })}
												</TableBody>
											</Table>
										</TableContainer>
										{/* <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={response.Trip.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
									</Paper>
								</Paper>
								{/* )} */}
							</TabPanel>
							<TabPanel value={value} index={1}>
								{response.stoppageReport === null ?
              <TableContainer component={Paper}>
										<Table aria-label="simple table">
											<TableHead>
												<TableRow>
													<TableCell
                      style={{ fontSize: "16px", fontWeight: "bold" }}>

														Loaded
													</TableCell>
													<TableCell
                      style={{ fontSize: "16px", fontWeight: "bold" }}>

														Unloading
													</TableCell>
													<TableCell
                      style={{ fontSize: "16px", fontWeight: "bold" }}>

														Duaration
													</TableCell>
													<TableCell
                      style={{ fontSize: "16px", fontWeight: "bold" }}>

														Stoppage
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell></TableCell>
													<TableCell></TableCell>
													<TableCell>No Data Found</TableCell>
													<TableCell></TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</TableContainer> :

              response.stoppageReport.map((loadingToUnloading, index) => {
                return loadingToUnloading.loadedFixTime == null ? null :
                <TableContainer component={Paper}>
												<Table
                  aria-label="simple table"
                  style={{ paddingRight: "50px" }}>

													<TableHead>
														<StyledTableRowStoppage>
															<TableCell
                        style={{ fontSize: "16px", fontWeight: "bold" }}>

																Loaded
															</TableCell>
															<TableCell
                        style={{ fontSize: "16px", fontWeight: "bold" }}>

																Unloading
															</TableCell>
															<TableCell
                        style={{ fontSize: "16px", fontWeight: "bold" }}>

																Duaration
															</TableCell>
															<TableCell
                        style={{ fontSize: "16px", fontWeight: "bold" }}>

																-
															</TableCell>
														</StyledTableRowStoppage>

														<TableRow>
															<TableCell style={TableRowData}>
																{loadingToUnloading.loadedFixTime}
															</TableCell>

															<TableCell style={TableRowData}>
																{" "}
																{loadingToUnloading.unloadingFixTime}
															</TableCell>

															<TableCell style={TableRowData}>
																{(() => {
                            if (loadingToUnloading.duration.d != "0") {
                              return (
                                " " +
                                " " +
                                loadingToUnloading.duration.d +
                                " " +
                                "Day" +
                                " " +
                                " ");

                            }
                          })()}
																{(() => {
                            if (loadingToUnloading.duration.h != "0") {
                              return (
                                " " +
                                " " +
                                loadingToUnloading.duration.h +
                                " " +
                                "Hour" +
                                " " +
                                " ");

                            }
                          })()}
																{(() => {
                            if (loadingToUnloading.duration.m != "0") {
                              return (
                                " " +
                                " " +
                                loadingToUnloading.duration.m +
                                " " +
                                "Min" +
                                " " +
                                " ");

                            }
                          })()}
																{(() => {
                            if (loadingToUnloading.duration.s != "0") {
                              return (
                                " " +
                                " " +
                                loadingToUnloading.duration.s +
                                " " +
                                "Sec");

                            }
                          })()}{" "}
															</TableCell>

															<TableCell style={TableRowData}>-</TableCell>
														</TableRow>

														{!loadingToUnloading.stopData.length ? null :
                      <StyledTableRowStoppage2>
																<TableCell
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold" }}>


																	<b>Sr No</b>
																</TableCell>
																<TableCell
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold" }}>


																	<b>Stop</b>
																</TableCell>
																<TableCell
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold" }}>


																	<b>Moving</b>
																</TableCell>
																<TableCell
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold" }}>


																	<b>Duration</b>
																</TableCell>
															</StyledTableRowStoppage2>}

													</TableHead>

													<TableBody>
														{loadingToUnloading.stopData.map((item, index) => {
                        return (
                          <TableRow aria-rowspan>
																	<TableCell>{index + 1}</TableCell>
																	<TableCell style={TableCellStyle}>
																		{item.stoppedTime}
																	</TableCell>
																	<TableCell style={TableCellStyle}>
																		{item.movingTime}
																		{/* <a href="https://maps.google.com/maps?q=<?php echo $sr['stoppedLatitude'] ?>,<?php echo $sr['stoppLongitude'] ?>&t=&z=6&ie=UTF8">
                                <i class="fas fa-map-marker-alt" style="color:red;"></i>
                                &nbsp;&nbsp;&nbsp;&nbsp;Click
                                </a> */}
																	</TableCell>
																	<TableCell
                            // align="center"
                            style={{ color: "blue" }}
                            onClick={() =>
                            window.open(
                            `https://maps.google.com/maps?q=${item.stoppedLatitude},${item.stoppLongitude}`,
                            "blank")}>



																		<LocationOnIcon
                              style={{
                                color: "red",
                                verticalAlign: "middle" }} />


																		{(() => {
                                if (item.StoppageTimeDuration.d != "0") {
                                  return (
                                    " " +
                                    " " +
                                    item.StoppageTimeDuration.d +
                                    " " +
                                    "Day" +
                                    " " +
                                    " ");

                                }
                              })()}
																		{(() => {
                                if (item.StoppageTimeDuration.h != "0") {
                                  return (
                                    " " +
                                    " " +
                                    item.StoppageTimeDuration.h +
                                    " " +
                                    "Hour" +
                                    " " +
                                    " ");

                                }
                              })()}
																		{(() => {
                                if (item.StoppageTimeDuration.m != "0") {
                                  return (
                                    " " +
                                    " " +
                                    item.StoppageTimeDuration.m +
                                    " " +
                                    "Min" +
                                    " " +
                                    " ");

                                }
                              })()}
																		{(() => {
                                if (item.StoppageTimeDuration.s != "0") {
                                  return (
                                    " " +
                                    " " +
                                    item.StoppageTimeDuration.s +
                                    " " +
                                    "Sec");

                                }
                              })()}
																	</TableCell>
																	{/* <TableCell> */}
																	{/* {" "} */}
																	{/* <a href="https://maps.google.com/maps?q=<?php echo $sr['movingLatitude'] ?>,<?php echo $sr['movingLongitude'] ?>&t=&z=6&ie=UTF8"><i class="fas fa-map-marker-alt" style="color:red;"></i>&nbsp;&nbsp;&nbsp;&nbsp;Click</a> */}
																	{/* </TableCell> */}
																	{/* <TableCell>Duration with link last item cell</TableCell> */}
																</TableRow>);

                      })}
													</TableBody>
												</Table>
											</TableContainer>;

              })}

							</TabPanel>
							<TabPanel value={value} index={2}>
								<MaterialTable
              title="Events List"
              columns={[
              {
                title: " Sr.No.",
                render: (rowData) => rowData.tableData.id + 1,
                align: "center",
                hidden: success === 0 },

              {
                title: "Event",
                field: "miningStatus",
                align: "center",
                width: "20%" },

              { title: "Time", field: "fixtime", align: "center" }]}

              data={response.deviceStatus}
              // data={
              // 	success == 1
              // 		? data
              // 		: [
              // 				{
              // 					srNo: "",
              // 					miningStatus: "No data available",
              // 					fixtime: "",
              // 				},
              // 		  ]
              // }
              actions={[
              {
                icon: () => <LocationOnIcon style={{ color: "red" }} />,
                tooltip: "Location ",
                hidden: success == 0,
                onClick: (event, rowData) => {
                  window.open(
                  `https://maps.google.com/maps?q=${rowData.latitude},${rowData.longitude}`,
                  "_blank");

                } }]}


              // icons={tableIcons}
              options={{
                emptyRowsWhenPaging: false,

                rowStyle: {
                  fontSize: 16 },


                actionsColumnIndex: -1,
                pageSize: 5,
                pageSizeOptions: [5, 10, 15, 20, 50, 100],
                headerStyle: {
                  width: "100px",
                  fontSize: 16,
                  backgroundColor: "#e4ecf2",
                  fontWeight: "bold",
                  position: "sticky",
                  top: 0 }, ...defaultTableOptions }} />



							</TabPanel>
						</div>
					</Grid>
				</Grid>}

		</div>);

};

export default TokenCopyView;